var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable, makeObservable } from 'mobx';
import { clamp } from '../../../../utils/helper/helper_math';
import { runtime } from '../../../../classes/runtime/Runtime';
export class WordTaskForm {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get wordTask() {
        return this.parent;
    }
    get longestWording() {
        return this.wordTask.wordings.map(wording => wording.wordingString).reduce((a, b) => (a.length > b.length ? a : b), '');
    }
    get maxWordingLength() {
        return this.longestWording.length;
    }
    manualInputAutoWidth = 0;
    get inputAutoWidth() {
        const perCharacter = this.actualInputFontSize * 0.8;
        const calculatedWidth = this.maxWordingLength * perCharacter;
        return clamp(Math.max(calculatedWidth, this.manualInputAutoWidth), 100, 800);
    }
    get actualInputFontSize() {
        const { input } = this.wordTask.ownAspect;
        if (input.activeOf.fontSizeManual)
            return input.valueOf.fontSizeManual;
        if (input.activeOf.fontSize)
            return input.valueOf.fontSize;
        if (input.aspectMount.domElement_observable) {
            return input.aspectMount.measureDom.parsedStyle.fontSize / input.context.stage.stageInnerMeasure.stageDiagonalRatio;
        }
        return 26;
    }
    get inputAutoFontSize() {
        const fontSize = 26;
        return clamp(fontSize, 16, 30);
    }
    get inputAutoSize() {
        return this.maxWordingLength;
    }
    focusInputField() {
        /* if (document.activeElement && document.activeElement.tagName === 'INPUT') {     mhicke 28.02.2021 PROBLEMS WITH MEOMORIZEPOINTS as OLD INPUT FIELD DOES NOT LOOSE FOCUS SOMETIMES
          return;
        } */
        // mhicke, 06.10.2021: Autofocus and keyboard require user interaction in safari if app isn't started from home screen
        // https://stackoverflow.com/questions/48547975/cant-set-focus-in-safari
        if (document.getElementsByClassName('ant-modal-mask').length > 0)
            return; // Modal is open
        if (!this.wordTask.isActiveWordTask)
            return;
        if (runtime.availablePackages.Defer && this.wordTask.context.app.menubar && this.wordTask.context.app.menubar.isAnyDialogOpen) {
            return;
        }
        const inputElement = this.wordTask.ownAspect.input.aspectMount.domElement;
        if (!inputElement) {
            return;
        }
        if (document.activeElement === inputElement)
            return;
        this.wordTask.wordTaskInput.dateOfInputFocus = new Date();
        inputElement.focus();
        if (inputElement.value.includes('_') || inputElement.value.includes(' ') || inputElement.value.includes(' ')) {
            // text mask
            inputElement.setSelectionRange(0, 0);
        }
    }
}
__decorate([
    observable
], WordTaskForm.prototype, "manualInputAutoWidth", void 0);
__decorate([
    computed
], WordTaskForm.prototype, "inputAutoWidth", null);
